import React, { useState } from "react";
import Modal from "../../../../components/Reusable/Modal";
import { useAppDispatch } from "../../../../hooks/hooks";
import { toast } from "react-toastify";
import { DeleteModalProps } from "../types";
import {
  deleteGamecardPlan,
  fetchGamecardPlans,
} from "../../../../features/auth/store/gamecardPlanSlice";

export const DeleteGameCardPlanModal: React.FC<DeleteModalProps> = ({
  id: gameCardPlanId,
  isOpen,
  onClose,
}) => {
  const dispatch = useAppDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDelete = async () => {
    if (gameCardPlanId === null) return;
    setIsSubmitting(true);
    try {
      await dispatch(deleteGamecardPlan(gameCardPlanId)).unwrap();
      toast.success("Game Card Plan deleted successfully! 🚀");
      onClose();
      dispatch(fetchGamecardPlans({}));
    } catch (err: any) {
      toast.error(err?.message || "Failed to delete plan");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2 className="text-xl font-bold mb-4">Delete Game Card Plan</h2>
      <div className="p-4">
        <p>Are you sure you want to delete this game card plan?</p>
        <div className="mt-4 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </Modal>
  );
};
